const options = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
} as Intl.DateTimeFormatOptions;

/* Format date by options (GB) */
export const formatDate = (dateString: string | number) =>
  new Date(dateString).toLocaleString('en-GB', options);

export const formatDateMini = (dateString: string | number) =>
  formatDate(dateString).substring(0, 8);

export const stripMarkdown = (text: string): string =>
  text
    .replace(/#{1,6}\s*/g, '')
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/\*(.+?)\*/g, '$1')
    .replace(/_{2}(.+?)_{2}/g, '$1')
    .replace(/_(.+?)_/g, '$1')
    .replace(/`(.+?)`/g, '$1')
    .replace(/^-{3,}$/gm, '')
    .replace(/\[(.+?)\]\(.+?\)/g, '$1')
    .replace(/\n+/g, ' ')
    .trim();

export const splitByLastDot = (text: string) => {
  if (text.indexOf('.') === -1) return [text];
  const index = text.lastIndexOf('.');
  return [text.slice(0, index), text.slice(index + 1)];
};
